import React                                                 from 'react';
import { KirokuCardBodyWeb, KirokuCardWeb, KirokuInputDate } from '../../../../ui';
import { useTranslation }                                    from 'react-i18next';
import { useHeadingQuestion }                                from '../../useSurvey';
import { useAsQuestionType }                                 from '../../../Recording';
import moment                                                from 'moment';
import QuestionCardTitle                                     from './QuestionCardTitle';
import { ButtonNext, getNext }                               from './getNextQuestion';
import { QuestionSkipped }                                   from './QuestionSkipped';
import ComponentWeb                                          from '../../../../ui/ComponentWeb';
import ComponentMobile                                       from '../../../../ui/ComponentMobile';
import KirokuInputDateTimeMobile                             from '../../../../ui/KirokuInputDateTimeMobile';

const width = window.innerWidth;

export function setDefaultAnswerDateTime(question) {
    return {
        ...question,
        answers: question[ 'defaultAnswer' ],
    };
}

export default function DateTimeQuestion({ question }) {

    const { t }                   = useTranslation();
    const { doAnswer, answering } = useAsQuestionType(question);
    const { content }             = useHeadingQuestion(question);

    return (<div id='component-question'>
        <div id='web-q' className='pb-3'>
            <KirokuCardWeb>
                <div className={ (width <= 768) && !!question.answers ? 'border-has-answer': ' '}>
                <QuestionCardTitle
                    isDisabled={question.isDisabled}
                    question={question}
                    handleResetAnswer={() => doAnswer(null, question.index + 1)}
                    hasAnswer={!!question.answers}
                />
                <KirokuCardBodyWeb>
                    <QuestionSkipped
                        isDisabled={question.isDisabled}
                    >
                        <span className='content-name-question'>{content}</span>
                        <div className="d-flex" style={{ flexWrap: 'wrap' }}>
                            <div className='answer-question' style={{ maxWidth: 250 }}>
                                <ComponentMobile>
                                    <div style={{width: 216}}>
                                        <KirokuInputDateTimeMobile
                                            readOnly={true}
                                            name={question.index}
                                            disabled={question.isDisabled}
                                            onChange={(timestampUnix) => {
                                                answering();
                                                doAnswer(
                                                    timestampUnix ? timestampUnix : null,
                                                    getNext({ ...question, isAnswers: !!timestampUnix }));
                                            }}
                                            value={question.answers}
                                        />
                                    </div>
                                </ComponentMobile>
                                <ComponentWeb>
                                    <KirokuInputDate
                                        className={'date-chart-search'}
                                        inputProps={{ disabled: question.isDisabled, readOnly: true }}
                                        value={question.answers ? moment.unix(question.answers) : null}
                                        timeFormat={t('dateTimeFormat.HourMinute')}
                                        dateFormat={t('dateTimeFormat.YearMonthDate')}
                                        onChange={(momentTime) => {
                                            answering();
                                            doAnswer(
                                                momentTime ? moment(momentTime).unix() : null,
                                                getNext({ ...question, isAnswers: !!momentTime }));
                                        }}
                                        locale={t('createRecord.Date')}
                                    />
                                </ComponentWeb>
                            </div>
                            <div className={'pr-2'} style={{ paddingTop: 10 }}
                            >
                                <ButtonNext
                                    question={question}
                                    onClick={() => {
                                        if(question.answers) {
                                            doAnswer(question.answers, getNext(question))
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </QuestionSkipped>
                </KirokuCardBodyWeb>
                </div>
            </KirokuCardWeb>
        </div>
    </div>);
}
